import { combineReducers } from 'redux'
import { blockSlice, callSlice, blacklistSlice, partnerSettingsSlice } from 'Pages/coliseum'

export const coliseum = combineReducers({
	[callSlice.name]: callSlice.reducer,
	[blockSlice.name]: blockSlice.reducer,
	[blacklistSlice.name]: blacklistSlice.reducer,
	[partnerSettingsSlice.name]: partnerSettingsSlice.reducer,
})
